import { useTranslation } from "react-i18next";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import * as XLSX from 'xlsx';
import { SkeletonTheme } from "react-loading-skeleton";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import { Field, Form, Formik } from "formik";
import { PaginationState } from "@tanstack/react-table";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import style from "./index.module.css";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import Loader from "../../shared/Ui/Loader/Loader";
import Cookies from "js-cookie";


function MainScreen() {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState<Date | undefined>(undefined);
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);
  const [dataObject, setDataObject] = useState<any>({
    startDate: undefined, // Начальная дата по умолчанию
    startTime: "", // Время для начальной даты по умолчанию
    endDate: undefined, // Конечная дата по умолчанию
    endTime: "", // Время для конечной даты по умолчанию
  });
  const [initialValues, setInitialValues] = useState({
    selectorData: null,
    pickerData: null,
  });
  const role = Cookies.get("role");

  const chartData = {
    series: [
      [
        {
          data: [217, 17], // Успешные и Ошибочные для первой категории
        },
      ],
      [
        {
          data: [342, 29], // Успешные и Ошибочные для второй категории
        },
      ],
      [
        {
          data: [415, 38], // Успешные и Ошибочные для третьей категории
        },
      ]
    ],
    series2: [
      [
        155, 40, 22 // Значения для первой категории
      ],
      [
        270, 25, 47 // Значения для второй категории
      ],
      [
        328, 30, 57 // Значения для третьей категории
      ]
    ],
    series3: [
      [
        {
          name: 'Отправленные',
          data: [114, 89, 14]
        },
        {
          name: 'Ошибочные',
          data: [13, 3, 1]
        }
      ],
      [
        {
          name: 'Отправленные',
          data: [180, 145, 28]
        },
        {
          name: 'Ошибочные',
          data: [19, 4, 2]
        }
      ],
      [
        {
          name: 'Отправленные',
          data: [215, 178, 35]
        },
        {
          name: 'Ошибочные',
          data: [23, 5, 3]
        }
      ]
    ]
  };



  const chartOptions: { series: number[]; options: ApexOptions } = {
    series: [155, 40, 22], // Значения для каждого сегмента
    options: {
      chart: {
        type: 'polarArea',
        height: 700,
        foreColor: '#000', // Цвет текста для шагов осей
      },
      stroke: {
        colors: ['#fff'],
      },
      fill: {
        opacity: 0.8,
      },
      colors: ['#00b074', '#125dae', '#ffcd30'],
      labels: ['Отправленно', 'Подтверждено', 'Ожидает подтверждения'], // Названия серий
      legend: {
        position: 'bottom',
        show: true, // Включаем легенду
        formatter: function (seriesName, opts) {
          // Форматируем отображение легенды
          const value = opts.w.config.series[opts.seriesIndex];
          return `${seriesName}: ${value}`;
        },
      },
      dataLabels: {
        enabled: false,
        formatter: (val, opts) => {
          return `${val}`;
        },
      },
      xaxis: {
        labels: {
          style: {
            fontSize: '14px',  // Увеличиваем размер шрифта для меток на оси X
            fontWeight: 'bold', // Жирный шрифт для оси X
          }
        }
      },
      yaxis: {
        labels: {
          style: {
            fontSize: '14px',  // Увеличиваем размер шрифта для меток на оси Y
            fontWeight: 'bold', // Жирный шрифт для оси Y
          }
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
          },
        },
      ],
    },
  };


  const barOptions: { series: { data: number[] }[]; options: ApexOptions } = {
    series: [
      {
        data: [217, 17], // Значения для "Успешные" и "Ошибочные"
      },
    ],
    options: {
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false, // Отключает панель инструментов, включая бургер-меню
        },
      },
      plotOptions: {
        bar: {
          columnWidth: '50%', // Ширина колонок
          barHeight: '100%',
          distributed: true,
        },
      },
      dataLabels: {
        enabled: true, // Включить отображение значений
        formatter: (val: number) => `${val}`, // Формат значения
      },
      legend: {
        position: 'bottom', // Легенда внизу
      },
      xaxis: {
        categories: ['Успешные', 'Ошибочные'], // Названия колонок
        labels: {
          show: false, // Включить метки на оси X (названия категорий)
        },
      },
      yaxis: {
        show: false, // Убрать ось Y
      },
      grid: {
        show: false, // Убрать сетку
      },
      colors: ['#00b074', '#FF4560'], // Цвета колонок: зеленый и красный
      tooltip: {
        enabled: false, // Включить тултип
        y: {
          formatter: (val: number) => `${val}`, // Показать только значение
        },
        x: {
          formatter: (val: number) => `${val}`, // Показать название категории
        },
      },
    },
  };

  const barDifferenceConfig: { series: any; options: ApexOptions } = {

    series: [{
      name: 'Отправленные',
      data: [114, 89, 14]
    }, {
      name: 'Ошибочные',
      data: [13, 3, 1]
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false, // Отключаем тулбар
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          columnWidth: '55%',
          borderRadius: 0,
          borderRadiusApplication: 'end'
        },
      },
      colors: ['#00b074', '#FF4560'],
      dataLabels: {
        enabled: true, // Включаем отображение значений
        style: {
          colors: ['#FFFFFF'], // Указываем белый цвет текста
          fontSize: '12px', // Размер шрифта для лучшей читаемости
          fontWeight: 'bold',
        },
        formatter: function (val) {
          return `${val}`; // Форматирование значения
        },
        offsetX: -10000,
        textAnchor: 'start',
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Еда', 'Напитки', 'Оборудование'],
        tickAmount: 7,
      },
      grid: {
        show: true, // Включаем сетку
        xaxis: {
          lines: {
            show: true, // Показываем вертикальные линии
          },
        },
        yaxis: {
          lines: {
            show: false, // Отключаем горизонтальные линии
          },
        },
      },
      yaxis: {
        show: true,
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return `${val}`
          }
        }
      }
    }
  }






  function onLoad() {

  }


  return (
    <div className="w-full h-full">


      <div className="rounded-lg overflow-x-auto  bg-white">
        <table className="max-w-full w-full leading-normal">
          <thead className="border-b-2 border-gray-300">
            <tr >
              <th
                className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                scope="col"
              >
                Торговая точка
              </th>
              <th
                className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                scope="col"
              >
                Общее количество заявок
              </th>

              <th
                className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                scope="col"
              >
                Статусы заявок
              </th>
              <th
                className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                scope="col"
              >
                Количество отправленных/ошибочных по категории
              </th>
            </tr>
          </thead>
          {isLoading ? (
            <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
              <tbody className="font-normal text-center">
                {new Array(10).fill(1).map((_, index) => (
                  <Loader />
                ))}
              </tbody>
            </SkeletonTheme>
          ) : [1].length === 0 || ![1]?.values ? (
            <tbody>
              <tr>
                <td colSpan={8} className="text-center py-5">
                  <div>
                    <EmptyListPlaceholderContent
                      title={t("Пользователей не найдено")}
                    // description={t("orderList.noOrdersDescription")}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody className="font-normal text-center">
              {['АЗК Z-27', 'АЗК Z-26', 'АГЗС Z-6']
                .filter((_, index) => role == "admin" || index === 0)
                .map((value, index) => (
                  <tr
                    key={`tr-${index}`}
                    className="cursor-pointer"
                    onClick={() => { }}
                  >

                    <td className="px-5 py-5 text-[16px] font-[600] border-b border-gray-200 text-gray-600">
                      {value}
                      {/* {value.email || "-"} */}
                    </td>
                    <td className="px-1 py-5 text-sm border-b border-gray-200 text-gray-600">
                      <div className="flex justify-center items-center h-full">
                        <ReactApexChart
                          options={barOptions.options}
                          series={chartData.series[index]}
                          type="bar"
                          height={280}
                          width={200}
                        />
                      </div>
                    </td>
                    <td className="px-1 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                      <div className="flex justify-center h-full ">
                        <ReactApexChart
                          options={chartOptions.options}
                          series={chartData.series2[index]}
                          type="polarArea"
                          height={280}
                        // width={400}
                        />
                      </div>
                    </td>
                    <td className="px-1 w-[40%] py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                      <div className="m-auto  items-center h-full">
                        <ReactApexChart options={barDifferenceConfig.options} series={chartData.series3[index]} type="bar" height={280} />
                      </div>
                    </td>


                  </tr>
                ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
}

export default MainScreen;
